import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Popover, useTheme } from '@mui/material'

import ServiceTypeAvatar from 'components/common/avatar/ServiceTypeAvatar'
import ServiceContent from './ServiceContent'

const ServiceDetails = ({ pricedServiceType, serviceId }) => {
  const [viewPopoverAnchorEl, setViewPopoverAnchorEl] = useState(null)
  const theme = useTheme()
  const handleViewPopoverOpen = event => {
    event.stopPropagation()
    setViewPopoverAnchorEl(event.currentTarget)
  }

  const handleViewPopoverClose = () => setViewPopoverAnchorEl(null)

  const isOpen = Boolean(viewPopoverAnchorEl)

  return (
    <>
      <ServiceTypeAvatar serviceType={pricedServiceType} onMouseEnter={handleViewPopoverOpen} onMouseLeave={handleViewPopoverClose} />

      <Popover
        sx={{ pointerEvents: 'none', zIndex: theme.zIndex.tooltip }}
        open={isOpen}
        anchorEl={viewPopoverAnchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClose={handleViewPopoverClose}
        disableRestoreFocus
        slotProps={{ paper: { sx: { width: '50vw' } } }}
      >
        <ServiceContent isOpen={isOpen} serviceId={serviceId} showServiceName isTagsViewOnly />
      </Popover>
    </>
  )
}

ServiceDetails.propTypes = {
  pricedServiceType: PropTypes.string,
  serviceId: PropTypes.string.isRequired,
}

export default ServiceDetails
